import { IconButton, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { FiMoon, FiSun } from "react-icons/fi";

const ThemeToggle = () => {
  const { toggleColorMode } = useColorMode();
  const IconComponent = useColorModeValue(FiMoon, FiSun);
  const label = useColorModeValue("Switch to dark mode", "Switch to light mode");

  return (
    <IconButton
      aria-label={label}
      icon={<IconComponent />}
      onClick={toggleColorMode}
      variant="ghost"
      size="md"
      fontSize="lg"
    />
  );
};

export default ThemeToggle;